import React, { Component } from 'react'
import { Box } from '../../styles.style'
import { MaskCellphone } from '../masks/masks'
import { ErrorMessage, getIn } from 'formik'
import { MuvicardService } from '../../../../services/muvicard.service'

class Cellphone extends Component {
	constructor(props) {
		super(props)

		this.state = {
			cellPhone: ''
		}
	}

	componentDidMount() {
		const { setFieldValue, userData } = this.props
		if (userData) {
			const { cellPhone } = userData
			if (cellPhone) {
				const maskedCellPhone = MaskCellphone(cellPhone)
				setFieldValue('cellPhone', maskedCellPhone)
				this.setState({ cellPhone: maskedCellPhone })
			}
		}
	}

	setCellphone = e => {
		const cellPhone = MaskCellphone(e.target.value)
		this.setState({ cellPhone })
	}

	nextPage = () => {
		const { userData, updateUserData } = this.props
		let newUserData = { ...userData }
		newUserData.cellPhone = this.props.values.cellPhone
		updateUserData(newUserData)

		const cellPhone = this.props.values.cellPhone.replace(/\D/g, '')
		const obj = { cellPhone }
		MuvicardService.sendPersonalData(obj).then(data => {
			if (data.success) {
				MuvicardService.proposalStepRegister('Celular', 'Atualização')
				this.props.nextStep()
			}
		})
	}

	render() {
		const {
			handleBlur,
			handleChange,
			prevStep,
			values,
			errors,
			touched
		} = this.props
		return (
			<Box className="box-cellphone">
				<div className="field">
					<header>
						<h5>Por favor, digite seu telefone celular</h5>
					</header>

					<div>
						<input
							autoComplete="off"
							type="text"
							placeholder="Celular"
							id="cellPhone"
							maxLength="15"
							name="cellPhone"
							value={this.state.cellPhone}
							onBlur={e => {
								handleBlur(e)
								handleChange(e)
							}}
							onChange={e => {
								this.setCellphone(e)
							}}
							onKeyUp={e => {
								handleChange(e)
							}}
							className={
								getIn(errors, 'cellPhone') &&
								getIn(touched, 'cellPhone')
									? 'field-error input-big'
									: 'input-big'
							}
						/>
						<ErrorMessage
							component="div"
							name="cellPhone"
							className="msg-error"
						/>
					</div>
				</div>

				<footer className="footer">
					<button
						className="button transparent"
						type="button"
						onClick={() => prevStep()}>
						Voltar
					</button>
					<button
						disabled={
							!values.cellPhone ||
							(errors.cellPhone && touched.cellPhone)
						}
						className="button"
						type="button"
						onClick={() => this.nextPage()}>
						Próximo
					</button>
				</footer>
			</Box>
		)
	}
}

export default Cellphone
